import React from 'react'
import PropTypes from 'prop-types'
import { Box, Typography } from '@material-ui/core'
import { useTheme } from '@material-ui/core/styles'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck } from '@fortawesome/pro-solid-svg-icons/faCheck'
import { faAsterisk } from '@fortawesome/pro-solid-svg-icons/faAsterisk'
import { faTimes } from '@fortawesome/pro-solid-svg-icons/faTimes'

export const LabeledCheckMark = ({ label, enabled, getStyle = null }) => {
  const theme = useTheme()
  const baseStyle = enabled ? theme.palette.success.main : theme.palette.text.disabled
  return (
    <Box>
      <FontAwesomeIcon
        icon={faCheck}
        style={{ color: getStyle ? getStyle(baseStyle) : baseStyle }}
      />
      <Typography
        component="span"
        style={{ color: getStyle && getStyle(), marginLeft: theme.spacing(1) }}
      >
        {label ? label : 'Yes'}
      </Typography>
    </Box>
  )
}
LabeledCheckMark.propTypes = {
  label: PropTypes.string,
  enabled: PropTypes.bool,
  getStyle: PropTypes.func,
}

export const LabeledX = ({ label, enabled, getStyle = null }) => {
  const theme = useTheme()
  const baseStyle = enabled ? theme.palette.success.main : theme.palette.text.disabled
  return (
    <Box>
      <FontAwesomeIcon
        icon={faTimes}
        style={{ color: getStyle ? getStyle(baseStyle) : baseStyle }}
      />
      <Typography
        ml={1}
        component="span"
        style={{ color: getStyle && getStyle(), marginLeft: theme.spacing(1) }}
      >
        {label ? label : 'No'}
      </Typography>
    </Box>
  )
}
LabeledX.propTypes = {
  label: PropTypes.string,
  enabled: PropTypes.bool,
  getStyle: PropTypes.func,
}

export const RequiredStar = ({ hideLabel, label, enabled, getStyle = null }) => {
  const theme = useTheme()
  const baseStyle = enabled ? theme.palette.success.main : theme.palette.text.disabled
  return (
    <Box>
      <FontAwesomeIcon
        icon={faAsterisk}
        style={{ color: getStyle ? getStyle(baseStyle) : baseStyle }}
      />
      {!hideLabel && (
        <Typography
          ml={1}
          component="span"
          style={{ color: getStyle && getStyle(), marginLeft: theme.spacing(1) }}
        >
          {label ? label : 'Required'}
        </Typography>
      )}
    </Box>
  )
}
RequiredStar.propTypes = {
  hideLabel: PropTypes.bool.isRequired,
  label: PropTypes.string,
  enabled: PropTypes.bool,
  getStyle: PropTypes.func,
}
